/* eslint-disable */

/* global jQuery, wp, ajaxurl, SUGL10n */

window.SUG = {}

window.SUG.App = (($) => {
  var $generator = $('#su-generator')
  var $search = $('#su-generator-search')
  var $searchClear = $('#su-generator-search-clear')
  var $filter = $('#su-generator-filter')
  var $choices = $('#su-generator-choices')
  var $choice = $('.su-generator-choice')
  var $settings = $('#su-generator-settings')
  var $prefix = $('#su-compatibility-mode-prefix')
  var $result = $('#su-generator-result')
  var $selected = $('#su-generator-selected')

  var self = {}

  self.state = {
    mceSelection: '',
    target: '',
    wpActiveEditor: null,
    context: '',
    insertArgs: '',
    defaultSettings: null,
    lastUsedRequest: null,
    preview: {
      timer: null,
      request: null
    }
  }

  var abortLastUsedRequest = () => {
    if (self.state.lastUsedRequest) {
      self.state.lastUsedRequest.abort()
      self.state.lastUsedRequest = null
    }
  }

  var showAllChoices = () => {
    $choice.css(
      {
        display: 'flex',
        opacity: 1
      }
    ).removeClass('su-generator-choice-first')
  }

  var toggleSearchClear = () => {
    $searchClear.toggle($search.val() !== '')
  }

  var clearSearch = () => {
    $search.val('')
    showAllChoices()
    toggleSearchClear()
  }

  var removePresetElement = ($preset) => {
    if (!$preset.length) {
      return
    }

    var $list = $preset.parents('.su-gp-list')

    $preset.remove()

    if ($list.find('span').length < 1) {
      $list.find('b').show()
    }
  }

  var showChoicesMode = () => {
    $settings.html('').hide()
    self.state.defaultSettings = null
    abortLastUsedRequest()
    $generator.removeClass('su-generator-settings-mode su-generator-pro-features-mode')
    $filter.show()
    $choices.show()
    showAllChoices()
  }

  var showSettingsMode = (isProFeaturesMode) => {
    $generator
      .toggleClass('su-generator-pro-features-mode', !!isProFeaturesMode)
      .addClass('su-generator-settings-mode')
    $choices.hide()
    $filter.hide()
  }

  var initGeneratorTabs = ($scope) => {
    $scope.find('.su-generator-tabs').each(
      function () {
        var $tabs = $(this)

        if ($tabs.data('suGeneratorTabs')) {
          return
        }

        var $fields = $tabs.closest('.su-generator-settings-fields')
        var $tabButtons = $tabs.find('.su-generator-tab')
        var $panels = $fields.find('.su-generator-tab-panel')

        var activateTab = (tab, focus) => {
          $tabButtons.each(
            function () {
              var $button = $(this)
              var isActive = String($button.data('tab')) === tab

              $button
                .toggleClass('su-generator-tab-active', isActive)
                .attr('aria-selected', isActive ? 'true' : 'false')

              if (isActive && focus) {
                $button.trigger('focus')
              }
            }
          )

          $panels.each(
            function () {
              var $panel = $(this)
              var isActive = String($panel.data('tab')) === tab

              $panel
                .toggleClass('su-generator-tab-panel-active', isActive)
                .attr('aria-hidden', isActive ? 'false' : 'true')

              if (isActive) {
                $panel.removeAttr('inert')
              } else {
                $panel.attr('inert', '')
              }
            }
          )
        }

        $tabs.on(
          'click',
          '.su-generator-tab',
          function (e) {
            activateTab(String($(this).data('tab')), false)
            e.preventDefault()
          }
        )

        $tabs.on(
          'keydown',
          '.su-generator-tab',
          function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Home' && e.key !== 'End') {
              return
            }

            var current = $tabButtons.index(this)
            var next = current

            if (e.key === 'ArrowLeft') {
              next = current <= 0 ? $tabButtons.length - 1 : current - 1
            } else if (e.key === 'ArrowRight') {
              next = current >= $tabButtons.length - 1 ? 0 : current + 1
            } else if (e.key === 'Home') {
              next = 0
            } else if (e.key === 'End') {
              next = $tabButtons.length - 1
            }

            activateTab(String($tabButtons.eq(next).data('tab')), true)
            e.preventDefault()
          }
        )

        activateTab(String($tabButtons.filter('.su-generator-tab-active').first().data('tab') || $tabButtons.first().data('tab')), false)
        $fields.addClass('su-generator-tabs-ready')
        $tabs.data('suGeneratorTabs', true)
      }
    )
  }

  var initDependentFields = ($scope) => {
    $scope.find('.su-generator-attr-container[data-depends]').each(
      function () {
        var $container = $(this)
        var dependencies = $container.data('depends')
        var $controls = $()

        if (!dependencies || typeof dependencies !== 'object') {
          return
        }

        var updateVisibility = () => {
          var visible = true

          $.each(
            dependencies,
            function (name, expected) {
              var $control = $scope.find('#su-generator-attr-' + name)
              var values = $.isArray(expected) ? expected : [expected]
              var current = String($control.val())
              var matches = values.map(String).indexOf(current) !== -1

              if (!$control.length || !matches) {
                visible = false
              }
            }
          )

          $container
            .toggle(visible)
            .attr('aria-hidden', visible ? 'false' : 'true')
        }

        $.each(
          dependencies,
          function (name) {
            $controls = $controls.add($scope.find('#su-generator-attr-' + name))
          }
        )

        $controls.on('change keyup blur', updateVisibility)
        updateVisibility()
      }
    )
  }

  var fallbackCopyText = (text) => {
    var textarea = document.createElement('textarea')

    textarea.value = text
    textarea.setAttribute('readonly', 'readonly')
    textarea.style.position = 'fixed'
    textarea.style.top = '-9999px'
    textarea.style.left = '-9999px'

    document.body.appendChild(textarea)
    textarea.select()

    var copied = false

    try {
      copied = document.execCommand('copy')
    } catch (error) {
      copied = false
    }

    document.body.removeChild(textarea)

    return copied
  }

  var setCopyButtonState = ($button, copied) => {
    var label = copied
      ? $button.data('copied-label')
      : $button.data('label')

    $button
      .toggleClass('su-generator-copy-copied', copied)
      .find('.su-generator-copy-label')
      .text(label)

    $button
      .find('i')
      .toggleClass('sui-copy', !copied)
      .toggleClass('sui-check', copied)
  }

  var parseSearchableValue = (value) => {
    if ($.isArray(value)) {
      return value.map((item) => String(item).trim()).filter((item) => item !== '')
    }

    return String(value || '')
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item !== '')
  }

  var readSearchableOptions = ($picker) => {
    var options = []

    $picker.find('.su-generator-searchable-select-option').each(
      function () {
        options.push(
          {
            value: String($(this).data('value')),
            label: String($(this).data('label'))
          }
        )
      }
    )

    return options
  }

  var parseSearchableOptionsHTML = (html) => {
    var options = []

    $('<select>' + html + '</select>').find('option').each(
      function () {
        var value = $(this).attr('value')

        if (typeof value !== 'undefined') {
          options.push(
            {
              value: String(value),
              label: $(this).text()
            }
          )
        }
      }
    )

    return options
  }

  var normalizeSearchableOptions = (options) => {
    if (!$.isArray(options)) {
      return []
    }

    return options
      .map(
        function (option) {
          if (!option || typeof option.value === 'undefined') {
            return false
          }

          var value = String(option.value)

          return {
            value: value,
            label: typeof option.label === 'undefined' ? value : String(option.label)
          }
        }
      )
      .filter(Boolean)
  }

  var parseSearchableAjaxOptions = (response) => {
    var data = response && response.success ? response.data : response
    var results = data && data.results ? data.results : data

    return normalizeSearchableOptions(results)
  }

  var initSearchableSelects = ($scope) => {
    var removeText = typeof SUGL10n === 'object' && SUGL10n.remove_selected
      ? SUGL10n.remove_selected
      : 'Remove selected item'

    $scope.find('.su-generator-searchable-select').each(
      function (index) {
        var $picker = $(this)

        if ($picker.data('suGeneratorSearchableSelect')) {
          return
        }

        var $value = $picker.find('.su-generator-searchable-select-value')
        var $control = $picker.find('.su-generator-searchable-select-control')
        var $tokens = $picker.find('.su-generator-searchable-select-tokens')
        var $input = $picker.find('.su-generator-searchable-select-input')
        var $dropdown = $picker.find('.su-generator-searchable-select-dropdown')
        var $empty = $picker.find('.su-generator-searchable-select-empty')
        var multiple = $picker.data('multiple') === true || $picker.data('multiple') === 'true'
        var placeholder = $picker.data('placeholder') || ''
        var emptyText = $picker.data('empty') || ''
        var loadingText = $picker.data('loading') || emptyText
        var tooShortText = $picker.data('too-short') || emptyText
        var ajaxAction = $picker.data('ajax-action') || ''
        var ajaxMinLength = parseInt($picker.data('ajax-min-length'), 10)
        var ajaxDelay = parseInt($picker.data('ajax-delay'), 10)
        var namespace = '.suGeneratorSearchableSelect' + index + '-' + Date.now()

        if (isNaN(ajaxMinLength)) {
          ajaxMinLength = ajaxAction ? 2 : 0
        }

        if (isNaN(ajaxDelay)) {
          ajaxDelay = 250
        }

        var state = {
          loading: false,
          emptyText: ajaxAction ? tooShortText : emptyText,
          options: normalizeSearchableOptions(readSearchableOptions($picker)),
          selected: parseSearchableValue($value.val())
        }
        var ajaxRequest = null
        var ajaxTimer = null

        var normalizeSelected = () => {
          var unique = []

          state.selected.forEach(
            function (value) {
              if (unique.indexOf(value) === -1) {
                unique.push(value)
              }
            }
          )

          state.selected = multiple ? unique : unique.slice(0, 1)
        }

        var getOptionLabel = (value) => {
          var label = value

          state.options.forEach(
            function (option) {
              if (option.value === value) {
                label = option.label
              }
            }
          )

          return label
        }

        var renderTokens = () => {
          $tokens.empty()

          state.selected.forEach(
            function (value) {
              var $token = $('<span/>', {
                class: 'su-generator-searchable-select-token',
                'data-value': value
              })

              $('<span/>', {
                class: 'su-generator-searchable-select-token-label'
              }).text(getOptionLabel(value)).appendTo($token)

              $('<button/>', {
                type: 'button',
                class: 'su-generator-searchable-select-token-remove',
                title: removeText,
                'aria-label': removeText
              }).html('&times;').appendTo($token)

              $tokens.append($token)
            }
          )

          $input.attr('placeholder', state.selected.length ? '' : placeholder)
        }

        var renderOptions = () => {
          var query = String($input.val() || '').toLowerCase()
          var visible = 0

          $dropdown.find('.su-generator-searchable-select-option').each(
            function () {
              var $option = $(this)
              var value = String($option.data('value'))
              var label = String($option.data('label'))
              var selected = state.selected.indexOf(value) !== -1
              var matched = !query ||
                label.toLowerCase().indexOf(query) !== -1 ||
                value.toLowerCase().indexOf(query) !== -1

              $option
                .toggle(matched && !state.loading)
                .toggleClass('su-generator-searchable-select-option-selected', selected)
                .attr('aria-selected', selected ? 'true' : 'false')

              if (matched && !state.loading) {
                visible++
              }
            }
          )

          $empty
            .text(state.loading ? loadingText : state.emptyText)
            .toggle(state.loading || visible < 1)
        }

        var render = () => {
          normalizeSelected()
          renderTokens()
          renderOptions()
        }

        var syncValue = (triggerChange) => {
          $value.val(state.selected.join(','))

          if (triggerChange) {
            $value.trigger('change')
          }
        }

        var resetAjaxSearch = (clearInput) => {
          if (!ajaxAction) {
            return
          }

          if (ajaxTimer) {
            window.clearTimeout(ajaxTimer)
            ajaxTimer = null
          }

          if (ajaxRequest) {
            ajaxRequest.abort()
            ajaxRequest = null
          }

          if (clearInput) {
            $input.val('')
          }

          state.loading = false
          state.emptyText = tooShortText
          setOptions([], true)
        }

        var open = () => {
          $picker.addClass('su-generator-searchable-select-open')

          if (ajaxAction) {
            requestAjaxOptions()
          } else {
            renderOptions()
          }
        }

        var close = () => {
          $picker.removeClass('su-generator-searchable-select-open')

          if (ajaxAction) {
            resetAjaxSearch(true)
          } else {
            $input.val('')
            renderOptions()
          }
        }

        var selectOption = (value) => {
          var index = state.selected.indexOf(value)

          if (multiple) {
            if (index === -1) {
              state.selected.push(value)
            } else {
              state.selected.splice(index, 1)
            }
          } else {
            state.selected = [value]
            close()
          }

          $input.val('')
          syncValue(true)

          if (ajaxAction) {
            resetAjaxSearch(false)
          } else {
            render()
          }

          if (multiple) {
            $picker.addClass('su-generator-searchable-select-open')
            window.setTimeout(
              function () {
                $input.focus()
              },
              0
            )
          } else {
            $input.blur()
          }
        }

        var mergeOptions = (options) => {
          normalizeSearchableOptions(options).forEach(
            function (option) {
              var index = -1

              state.options.forEach(
                function (current, currentIndex) {
                  if (current.value === option.value) {
                    index = currentIndex
                  }
                }
              )

              if (index === -1) {
                state.options.push(option)
              } else {
                state.options[index] = option
              }
            }
          )
        }

        var setOptions = (options, keepKnownOptions) => {
          options = normalizeSearchableOptions(options)
          $dropdown.find('.su-generator-searchable-select-option').remove()

          if (keepKnownOptions) {
            mergeOptions(options)
          } else {
            state.options = options
          }

          options.forEach(
            function (option) {
              $('<button/>', {
                type: 'button',
                class: 'su-generator-searchable-select-option',
                'data-value': option.value,
                'data-label': option.label,
                role: 'option'
              }).text(option.label).insertBefore($empty)
            }
          )

          render()
        }

        var loadAjaxOptions = (data, labelsOnly) => {
          if (!ajaxAction) {
            return
          }

          data = $.extend({ action: ajaxAction }, data)

          if (!labelsOnly && ajaxRequest) {
            ajaxRequest.abort()
          }

          var request = $.ajax(
            {
              type: 'POST',
              url: ajaxurl,
              data: data,
              dataType: 'json',
              beforeSend: function () {
                if (!labelsOnly) {
                  state.loading = true
                  renderOptions()
                }
              },
              success: function (response) {
                var options = parseSearchableAjaxOptions(response)

                if (labelsOnly) {
                  mergeOptions(options)
                  render()
                } else {
                  setOptions(options, true)
                }
              },
              complete: function () {
                if (!labelsOnly && ajaxRequest === request) {
                  ajaxRequest = null
                  state.loading = false
                  renderOptions()
                }
              }
            }
          )

          if (!labelsOnly) {
            ajaxRequest = request
          }
        }

        var loadSelectedLabels = () => {
          if (!ajaxAction || !state.selected.length) {
            return
          }

          var unknown = state.selected.filter(
            function (value) {
              return getOptionLabel(value) === value
            }
          )

          if (unknown.length) {
            loadAjaxOptions({ ids: unknown.join(',') }, true)
          }
        }

        var requestAjaxOptions = () => {
          if (!ajaxAction) {
            renderOptions()
            return
          }

          var query = String($input.val() || '').trim()

          if (ajaxTimer) {
            window.clearTimeout(ajaxTimer)
            ajaxTimer = null
          }

          if (ajaxRequest) {
            ajaxRequest.abort()
            ajaxRequest = null
            state.loading = false
          }

          if (query.length < ajaxMinLength) {
            resetAjaxSearch(false)
            return
          }

          state.emptyText = emptyText
          renderOptions()

          ajaxTimer = window.setTimeout(
            function () {
              ajaxTimer = null
              loadAjaxOptions({ search: query }, false)
            },
            ajaxDelay
          )
        }

        var api = {
          clear: function () {
            state.selected = []
            syncValue(true)
            render()
          },
          setLoading: function (loading) {
            state.loading = loading
            renderOptions()
          },
          setEmptyText: function (text) {
            state.emptyText = text || emptyText
            renderOptions()
          },
          setOptions: setOptions
        }

        $picker.data('suGeneratorSearchableSelect', api)

        $control.on(
          'click',
          function () {
            $input.focus()
            open()
          }
        )

        $input.on(
          {
            focus: open,
            input: function () {
              $picker.addClass('su-generator-searchable-select-open')

              if (ajaxAction) {
                requestAjaxOptions()
              } else {
                renderOptions()
              }
            },
            keydown: function (e) {
              if (e.keyCode === 13) {
                var $first = $dropdown.find('.su-generator-searchable-select-option:visible:first')

                if ($first.length) {
                  e.preventDefault()
                  selectOption(String($first.data('value')))
                }
              }

              if (e.keyCode === 27) {
                close()
              }

              if (e.keyCode === 8 && $input.val() === '' && state.selected.length) {
                state.selected.pop()
                syncValue(true)

                if (ajaxAction) {
                  resetAjaxSearch(false)
                } else {
                  render()
                }
              }
            }
          }
        )

        $dropdown.on(
          'mousedown',
          '.su-generator-searchable-select-option',
          function (e) {
            e.preventDefault()
            selectOption(String($(this).data('value')))
          }
        )

        $tokens.on(
          'click',
          '.su-generator-searchable-select-token-remove',
          function (e) {
            var value = String($(this).closest('.su-generator-searchable-select-token').data('value'))
            var index = state.selected.indexOf(value)

            if (index !== -1) {
              state.selected.splice(index, 1)
              syncValue(true)
              render()
            }

            e.preventDefault()
            e.stopPropagation()
            $input.focus()
          }
        )

        $value.on(
          'change keyup blur',
          function () {
            state.selected = parseSearchableValue($value.val())
            render()
            loadSelectedLabels()
          }
        )

        $(document).on(
          'mousedown' + namespace,
          function (e) {
            if (!$picker.is(e.target) && $picker.has(e.target).length === 0) {
              close()
            }
          }
        )

        render()
        loadSelectedLabels()
      }
    )

    $scope.find('.su-generator-searchable-select[data-taxonomy-field]').each(
      function () {
        var $terms = $(this)
        var taxonomyField = $terms.data('taxonomy-field')
        var $taxonomy = $scope.find('#su-generator-attr-' + taxonomyField)

        if (!$taxonomy.length) {
          return
        }

        var loadTerms = function (clearSelection) {
          var tax = $taxonomy.val()
          var api = $terms.data('suGeneratorSearchableSelect')
          var request = $terms.data('suGeneratorTermsRequest')

          if (!api) {
            return
          }

          if (request) {
            request.abort()
          }

          if (clearSelection) {
            api.clear()
          }

          if (!tax || tax === 'any') {
            api.setOptions([])
            api.setLoading(false)
            return
          }

          api.setOptions([])

          request = $.ajax(
            {
              type: 'POST',
              url: ajaxurl,
              data: {
                action: 'su_generator_get_terms',
                tax: tax,
                noselect: true
              },
              dataType: 'html',
              beforeSend: function () {
                api.setLoading(true)
              },
              success: function (data) {
                api.setOptions(parseSearchableOptionsHTML(data))
              },
              complete: function () {
                api.setLoading(false)
              }
            }
          )

          $terms.data('suGeneratorTermsRequest', request)
        }

        $taxonomy.on(
          'change',
          function () {
            loadTerms(true)
          }
        )

        if ($taxonomy.val()) {
          loadTerms(false)
        }
      }
    )
  }

  var initSortableCheckboxes = ($scope) => {
    $scope.find('.su-generator-sortable-checkboxes').each(
      function () {
        var $picker = $(this)

        if ($picker.data('suGeneratorSortableCheckboxes')) {
          return
        }

        var $value = $picker.find('.su-generator-sortable-checkboxes-value')
        var $list = $picker.find('.su-generator-sortable-checkboxes-list')
        var baseOrder = []
        var syncing = false

        $list.find('.su-generator-sortable-checkboxes-item').each(
          function () {
            baseOrder.push(String($(this).data('value')))
          }
        )

        var getItem = (value) => $list.find('.su-generator-sortable-checkboxes-item').filter(
          function () {
            return String($(this).data('value')) === value
          }
        ).first()

        var orderedValuesFromInput = () => {
          var selected = parseSearchableValue($value.val())
          var ordered = []

          selected.forEach(
            function (value) {
              if (baseOrder.indexOf(value) !== -1 && ordered.indexOf(value) === -1) {
                ordered.push(value)
              }
            }
          )

          baseOrder.forEach(
            function (value) {
              if (ordered.indexOf(value) === -1) {
                ordered.push(value)
              }
            }
          )

          return ordered
        }

        var syncFromValue = () => {
          if (syncing) {
            return
          }

          var selected = parseSearchableValue($value.val())

          orderedValuesFromInput().forEach(
            function (value) {
              $list.append(getItem(value))
            }
          )

          $list.find('.su-generator-sortable-checkboxes-item').each(
            function () {
              var value = String($(this).data('value'))
              $(this).find('.su-generator-sortable-checkboxes-input').prop(
                'checked',
                selected.indexOf(value) !== -1
              )
            }
          )
        }

        var updateValue = () => {
          var selected = []

          $list.find('.su-generator-sortable-checkboxes-item').each(
            function () {
              if ($(this).find('.su-generator-sortable-checkboxes-input').prop('checked')) {
                selected.push(String($(this).data('value')))
              }
            }
          )

          syncing = true
          $value.val(selected.join(', ')).trigger('change')
          syncing = false
        }

        if ($.fn.sortable) {
          $list.sortable(
            {
              handle: '.su-generator-sortable-checkboxes-handle',
              items: '.su-generator-sortable-checkboxes-item',
              placeholder: 'su-generator-sortable-checkboxes-placeholder',
              forcePlaceholderSize: true,
              tolerance: 'pointer',
              stop: function () {
                updateValue()
              }
            }
          )
        }

        $list.on('change', '.su-generator-sortable-checkboxes-input', updateValue)
        $value.on('change keyup blur', syncFromValue)
        $picker.data('suGeneratorSortableCheckboxes', true)
        syncFromValue()
      }
    )
  }

  var initImageRadios = ($scope) => {
    $scope.find('.su-generator-image-radio').each(
      function () {
        var $picker = $(this)

        if ($picker.data('suGeneratorImageRadio')) {
          return
        }

        var $value = $picker.find('.su-generator-image-radio-value')
        var $inputs = $picker.find('.su-generator-image-radio-input')
        var syncing = false

        var getInputByValue = (value) => $inputs.filter(
          function () {
            return String($(this).val()) === value
          }
        ).first()

        var syncFromValue = () => {
          if (syncing) {
            return
          }

          var value = String($value.val())
          var $input = getInputByValue(value)

          if (!$input.length) {
            $input = $inputs.first()
          }

          $inputs.prop('checked', false)
          $input.prop('checked', true)

          if (String($value.val()) !== String($input.val())) {
            syncing = true
            $value.val($input.val()).trigger('change')
            syncing = false
          }
        }

        var updateValue = () => {
          var $checked = $inputs.filter(':checked')

          if (!$checked.length) {
            return
          }

          syncing = true
          $value.val($checked.val()).trigger('change')
          syncing = false
        }

        $inputs.on('change', updateValue)
        $value.on('change keyup blur', syncFromValue)
        $picker.data('suGeneratorImageRadio', true)
        syncFromValue()
      }
    )
  }

  var initRadios = ($scope) => {
    $scope.find('.su-generator-radio').each(
      function () {
        var $picker = $(this)

        if ($picker.data('suGeneratorRadio')) {
          return
        }

        var $value = $picker.find('.su-generator-radio-value')
        var $inputs = $picker.find('.su-generator-radio-input')
        var syncing = false

        var getInputByValue = (value) => $inputs.filter(
          function () {
            return String($(this).val()) === value
          }
        ).first()

        var syncFromValue = () => {
          if (syncing) {
            return
          }

          var value = String($value.val())
          var $input = getInputByValue(value)

          if (!$input.length) {
            $input = $inputs.first()
          }

          $inputs.prop('checked', false)
          $input.prop('checked', true)

          if (String($value.val()) !== String($input.val())) {
            syncing = true
            $value.val($input.val()).trigger('change')
            syncing = false
          }
        }

        var updateValue = () => {
          var $checked = $inputs.filter(':checked')

          if (!$checked.length) {
            return
          }

          syncing = true
          $value.val($checked.val()).trigger('change')
          syncing = false
        }

        $inputs.on('change', updateValue)
        $value.on('change keyup blur', syncFromValue)
        $picker.data('suGeneratorRadio', true)
        syncFromValue()
      }
    )
  }

  var isTransparentColor = (value) => String(value || '').trim().toLowerCase() === 'transparent'

  var getFallbackColor = ($picker, $value) => {
    var lastColor = $picker.data('suGeneratorLastColor')
    var defaultColor = $picker.closest('.su-generator-attr-container').data('default')
    var currentColor = $value.val()

    if (lastColor && !isTransparentColor(lastColor)) {
      return lastColor
    }

    if (defaultColor && !isTransparentColor(defaultColor)) {
      return defaultColor
    }

    if (currentColor && !isTransparentColor(currentColor)) {
      return currentColor
    }

    return '#000000'
  }

  var initColorPickers = ($scope) => {
    $scope.find('.su-generator-select-color').each(
      function () {
        var $picker = $(this)

        if ($picker.data('suGeneratorSelectColor')) {
          return
        }

        var $wheel = $picker.find('.su-generator-select-color-wheel').filter(':first')
        var $value = $picker.find('.su-generator-select-color-value').filter(':first')
        var $transparent = $picker.find('.su-generator-select-color-transparent-input').filter(':first')
        var allowTransparent = $picker.hasClass('su-generator-select-color-allow-transparent') && $transparent.length > 0

        var updateTransparentState = () => {
          if (!allowTransparent) {
            return
          }

          var value = String($value.val() || '').trim()
          var isTransparent = isTransparentColor(value)

          if (value !== '' && !isTransparent) {
            $picker.data('suGeneratorLastColor', value)
          }

          $picker.toggleClass('su-generator-select-color-transparent-active', isTransparent)
          $transparent.prop('checked', isTransparent)

          if (isTransparent) {
            $wheel.hide()
          }
        }

        $wheel.farbtastic($value)

        $value.focus(
          function () {
            if (!allowTransparent || !isTransparentColor($value.val())) {
              $wheel.show()
            }
          }
        )

        $value.blur(
          function () {
            $wheel.hide()
          }
        )

        if (allowTransparent) {
          $transparent.on(
            'change',
            function () {
              if ($transparent.prop('checked')) {
                var color = String($value.val() || '').trim()

                if (color !== '') {
                  $picker.data('suGeneratorLastColor', color)
                }

                $value.val('transparent')
              } else {
                $value.val(getFallbackColor($picker, $value))
              }

              updateTransparentState()
              $value.trigger('change')
            }
          )

          $value.on('change keyup blur', updateTransparentState)
          updateTransparentState()
        }

        $picker.data('suGeneratorSelectColor', true)
      }
    )
  }

  var clampBorderNewPercent = (value, fallback) => {
    var number = parseInt(value, 10)

    if (isNaN(number)) {
      number = fallback
    }

    return Math.max(0, Math.min(100, number))
  }

  var normalizeBorderNewHex = (value, fallback) => {
    var match = String(value || '').trim().match(/^#?([a-f0-9]{3}|[a-f0-9]{6})$/i)

    if (!match) {
      return fallback || '#000000'
    }

    var hex = match[1].toLowerCase()

    if (hex.length === 3) {
      hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2)
    }

    return '#' + hex
  }

  var borderNewHexToRgb = (hex) => {
    hex = normalizeBorderNewHex(hex).replace('#', '')

    return {
      red: parseInt(hex.substr(0, 2), 16),
      green: parseInt(hex.substr(2, 2), 16),
      blue: parseInt(hex.substr(4, 2), 16)
    }
  }

  var borderNewRgbToHex = (red, green, blue) => {
    var toHex = (value) => {
      value = Math.max(0, Math.min(255, parseInt(value, 10) || 0)).toString(16)
      return value.length === 1 ? '0' + value : value
    }

    return '#' + toHex(red) + toHex(green) + toHex(blue)
  }

  var formatBorderNewAlpha = (percent) => Number((clampBorderNewPercent(percent, 100) / 100).toFixed(2)).toString()

  var formatBorderNewColor = (hex, alpha) => {
    alpha = clampBorderNewPercent(alpha, 100)
    hex = normalizeBorderNewHex(hex)

    if (alpha >= 100) {
      return hex
    }

    var rgb = borderNewHexToRgb(hex)

    return 'rgba(' + rgb.red + ',' + rgb.green + ',' + rgb.blue + ',' + formatBorderNewAlpha(alpha) + ')'
  }

  var parseBorderNewColor = (value) => {
    value = String(value || '').trim()

    if (isTransparentColor(value)) {
      return {
        hex: '#000000',
        alpha: 0
      }
    }

    var hex = normalizeBorderNewHex(value, '')

    if (hex) {
      return {
        hex: hex,
        alpha: 100
      }
    }

    var rgba = value.match(/^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*([0-9.]+)\s*)?\)$/i)

    if (rgba) {
      var alpha = typeof rgba[4] === 'undefined'
        ? 1
        : Math.max(0, Math.min(1, parseFloat(rgba[4]) || 0))

      return {
        hex: borderNewRgbToHex(rgba[1], rgba[2], rgba[3]),
        alpha: Math.round(alpha * 100)
      }
    }

    return {
      hex: '#000000',
      alpha: 100
    }
  }

  var getBorderNewSelectValue = ($select, value, fallback) => {
    value = String(value || '')

    var hasValue = $select.find('option').filter(
      function () {
        return String($(this).val()) === value
      }
    ).length > 0

    if (hasValue) {
      return value
    }

    return fallback || String($select.find('option:first').val() || '')
  }

  var parseBorderNewValue = (value, $width, $style) => {
    var parsed = {
      width: getBorderNewSelectValue($width, '1px', '1px'),
      style: getBorderNewSelectValue($style, 'solid', 'solid'),
      hex: '#000000',
      alpha: 100
    }

    value = String(value || '').trim()

    if (value.toLowerCase() === 'none') {
      parsed.width = getBorderNewSelectValue($width, '0px', parsed.width)
      parsed.alpha = 0
      return parsed
    }

    var border = value.match(/^(\d+(?:\.\d+)?)px\s+([a-z-]+)\s+(.+)$/i)

    if (!border) {
      return parsed
    }

    parsed.width = getBorderNewSelectValue($width, parseInt(border[1], 10) + 'px', parsed.width)
    parsed.style = getBorderNewSelectValue($style, border[2].toLowerCase(), parsed.style)

    var color = parseBorderNewColor(border[3])

    parsed.hex = color.hex
    parsed.alpha = color.alpha

    return parsed
  }

  var setBorderNewPickerOpen = ($picker, open) => {
    $picker.toggleClass('su-generator-border-new-open', open)
    $picker.find('.su-generator-border-new-popover').filter(':first').prop('hidden', !open)
    $picker.find('.su-generator-border-new-color-button').filter(':first').attr('aria-expanded', open ? 'true' : 'false')
  }

  var bindBorderNewDocumentEvents = () => {
    if ($(document).data('suGeneratorBorderNewDocument')) {
      return
    }

    $(document).on(
      'mousedown.suGeneratorBorderNew',
      function (e) {
        $('.su-generator-border-new-open').each(
          function () {
            var $picker = $(this)

            if ($picker.is(e.target) || $picker.has(e.target).length) {
              return
            }

            setBorderNewPickerOpen($picker, false)
          }
        )
      }
    )

    $(document).data('suGeneratorBorderNewDocument', true)
  }

  var initBorderNewPickers = ($scope) => {
    bindBorderNewDocumentEvents()

    $scope.find('.su-generator-border-new').each(
      function () {
        var $picker = $(this)

        if ($picker.data('suGeneratorBorderNew')) {
          return
        }

        var $width = $picker.find('.su-generator-border-new-width').filter(':first')
        var $style = $picker.find('.su-generator-border-new-style').filter(':first')
        var $button = $picker.find('.su-generator-border-new-color-button').filter(':first')
        var $swatch = $picker.find('.su-generator-border-new-color-swatch-color').filter(':first')
        var $label = $picker.find('.su-generator-border-new-color-label').filter(':first')
        var $wheel = $picker.find('.su-generator-border-new-color-wheel').filter(':first')
        var $hex = $picker.find('.su-generator-border-new-color-value').filter(':first')
        var $alphaRange = $picker.find('.su-generator-border-new-alpha-range').filter(':first')
        var $alphaValue = $picker.find('.su-generator-border-new-alpha-value').filter(':first')
        var $value = $picker.find('.su-generator-border-new-value').filter(':first')
        var syncing = false

        var updateColorPreview = () => {
          var color = formatBorderNewColor($hex.val(), $alphaRange.val())

          $swatch.css('background-color', color)
          $label.text(color)
        }

        var syncAlphaControls = ($source) => {
          var alpha = clampBorderNewPercent($source.val(), 100)

          $alphaRange.val(alpha)
          $alphaValue.val(alpha)

          return alpha
        }

        var updateValue = () => {
          if (syncing) {
            return
          }

          var color = formatBorderNewColor($hex.val(), syncAlphaControls($alphaRange))

          syncing = true
          $value.val($width.val() + ' ' + $style.val() + ' ' + color).trigger('change')
          syncing = false

          updateColorPreview()
        }

        var syncFromValue = () => {
          if (syncing) {
            return
          }

          var parsed = parseBorderNewValue($value.val(), $width, $style)

          syncing = true
          $width.val(parsed.width)
          $style.val(parsed.style)
          $hex.val(parsed.hex).trigger('change')
          $alphaRange.val(parsed.alpha)
          $alphaValue.val(parsed.alpha)
          syncing = false

          updateColorPreview()
        }

        $wheel.farbtastic($hex)

        $width.on('change', updateValue)
        $style.on('change', updateValue)
        $hex.on('change keyup blur', updateValue)

        $alphaRange.on(
          'input change',
          function () {
            syncAlphaControls($alphaRange)
            updateValue()
          }
        )

        $alphaValue.on(
          'change keyup blur',
          function () {
            syncAlphaControls($alphaValue)
            updateValue()
          }
        )

        $value.on('change keyup blur', syncFromValue)

        $button.on(
          'click',
          function (e) {
            setBorderNewPickerOpen($picker, !$picker.hasClass('su-generator-border-new-open'))
            e.preventDefault()
          }
        )

        $picker.on(
          'keydown',
          function (e) {
            if (e.key === 'Escape') {
              setBorderNewPickerOpen($picker, false)
            }
          }
        )

        $picker.data('suGeneratorBorderNew', true)
        syncFromValue()
      }
    )
  }

  self.init = () => {
    $('#su-generator-filter a').click(
      function (e) {
        // Prepare data
        var filter = $(this).data('filter')
        // If filter All, show all choices
        if (filter === 'all') {
          $choice.css(
            {
              display: 'flex'
            }
          ).removeClass('su-generator-choice-first')
        } else { // Else run search
          var regex = new RegExp(filter, 'gi')
          // Hide all choices
          $choice.css({ display: 'none' })
          // Find searched choices and show
          $choice.each(
            function () {
              // Get shortcode name
              var group = $(this).data('group')
              // Show choice if matched
              if (group.match(regex) !== null) {
                $(this)
                  .css({ display: 'flex' })
                  .removeClass('su-generator-choice-first')
              }
            }
          )
        }
        e.preventDefault()
      }
    )
    // Go to home link
    $('#su-generator').on(
      'click',
      '.su-generator-home',
      function (e) {
        // Clear search field
        clearSearch()
        // Show choices panel
        showChoicesMode()
        // Clear selection
        self.state.mceSelection = ''
        // Focus search field
        $search.focus()
        e.preventDefault()
      }
    )
    // Generator close button
    $('#su-generator').on(
      'click',
      '.su-generator-close',
      function (e) {
        // Close popup
        $.magnificPopup.close()
        // Prevent default action
        e.preventDefault()
      }
    )
    // Search field
    $search.on(
      {
        focus: function () {
          // Clear field
          clearSearch()
          // Show choices panel
          showChoicesMode()
        },
        keyup: function (e) {
          // Prepare vars
          var $first = $('.su-generator-choice-first:first')
          var val = $(this).val()
          var regex = new RegExp(val, 'gi')
          var best = 0
          // Hotkey action
          if (e.keyCode === 13 && $first.length > 0) {
            e.preventDefault()
            $(this).val('').blur()
            $first.trigger('click')
          }
          // Hide all choices
          $choice.css(
            {
              display: 'none'
            }
          ).removeClass('su-generator-choice-first')
          // Loop and highlight choices
          $choice.each(
            function () {
              // Get choice data
              var data = $(this).data()
              var id = data.shortcode
              var name = data.name
              var desc = data.desc
              var group = data.group
              var matches = ([id, name, desc, group].join(' ')).match(regex)
              // Highlight choice if matched
              if (matches !== null) {
                // Highlight current choice
                $(this).css(
                  {
                    display: 'flex'
                  }
                )
                // Check for exact match
                if (val === id) {
                  // Remove primary class from all choices
                  $choice.removeClass('su-generator-choice-first')
                  // Add primary class to the current choice
                  $(this).addClass('su-generator-choice-first')
                  // Prevent selecting by matches number
                  best = 999
                } else if (matches.length > best) { // Check matches length
                  // Remove primary class from all choices
                  $choice.removeClass('su-generator-choice-first')
                  // Add primary class to the current choice
                  $(this).addClass('su-generator-choice-first')
                  // Save the score
                  best = matches.length
                }
              }
            }
          )
          // Remove primary class if search field is empty
          if (val === '') {
            $choice.removeClass('su-generator-choice-first')
          }

          toggleSearchClear()
        }
      }
    )
    // Clear search button
    $searchClear.on(
      'click',
      function (e) {
        clearSearch()
        showChoicesMode()
        $search.focus()
        e.preventDefault()
      }
    )
    // Click on shortcode choice
    $choice.on(
      'click',
      function (e) {
        var $selectedChoice = $(this)
        // Prepare data
        var shortcode = $selectedChoice.data('shortcode')
        var isProChoice = $selectedChoice.hasClass('su-generator-choice-is-pro')
        // Load shortcode options
        $.ajax(
          {
            type: 'POST',
            url: ajaxurl,
            data: {
              action: 'su_generator_settings',
              shortcode: shortcode
            },
            beforeSend: function () {
              if (isProChoice) {
                $settings.removeClass('su-generator-loading').hide()
                return
              }

              // Switch to settings panel
              showSettingsMode(false)
              // Show loading animation
              $settings.addClass('su-generator-loading').show()
            },
            success: function (data) {
              // Hide loading animation
              $settings.removeClass('su-generator-loading')
              // Insert new HTML
              $settings.html(data)
              var isProFeaturesMode = $settings.find('.su-generator-pro-features-banner').length > 0
              $generator.toggleClass(
                'su-generator-pro-features-mode',
                isProFeaturesMode
              )
              if (isProChoice) {
                showSettingsMode(isProFeaturesMode)
                $settings.show()
              }
              // Store server-rendered defaults before applying editor selection or saved settings.
              self.state.defaultSettings = $.extend({}, self.getSettings())
              // Apply selected text to the content field
              var $content = $('#su-generator-content')
              if (typeof self.state.mceSelection !== 'undefined' && self.state.mceSelection !== '' && $content.attr('type') !== 'hidden') {
                $content.val(self.state.mceSelection)
              }
              // Init range pickers
              $('.su-generator-range-picker').each(
                function (index) {
                  var $picker = $(this)
                  var $val = $picker.find('input')
                  var min = $val.attr('min')
                  var max = $val.attr('max')
                  var step = $val.attr('step')
                  // Apply noUIslider
                  $val.simpleSlider(
                    {
                      snap: true,
                      step: step,
                      range: [min, max]
                    }
                  )
                  $val.show()
                  $val.on(
                    'keyup blur',
                    function (e) {
                      $val.simpleSlider('setValue', $val.val())
                    }
                  )
                }
              )
              // Init color pickers
              initColorPickers($settings)
              // Init new border pickers
              initBorderNewPickers($settings)
              // Init image sourse pickers
              $('.su-generator-isp').each(
                function () {
                  var $picker = $(this)
                  var $sources = $picker.find('.su-generator-isp-sources')
                  var $source = $picker.find('.su-generator-isp-source')
                  var $addMedia = $picker.find('.su-generator-isp-add-media')
                  var $images = $picker.find('.su-generator-isp-images')
                  var $cats = $picker.find('.su-generator-isp-categories')
                  var $taxes = $picker.find('.su-generator-isp-taxonomies')
                  var $terms = $('.su-generator-isp-terms')
                  var $val = $picker.find('.su-generator-attr')
                  var frame
                  // Update hidden value
                  var update = function () {
                    var val = 'none'
                    var ids = ''
                    var source = $sources.val()
                    // Media library
                    if (source === 'media') {
                      var images = []
                      $images.find('span').each(
                        function (i) {
                          images[i] = $(this).data('id')
                        }
                      )
                      if (images.length > 0) {
                        ids = images.join(',')
                      }
                    }
                    // Category
                    else if (source === 'category') {
                      var categories = $cats.val() || []
                      if (categories.length > 0) {
                        ids = categories.join(',')
                      }
                    }
                    // Taxonomy
                    else if (source === 'taxonomy') {
                      var tax = $taxes.val() || ''
                      var terms = $terms.val() || []
                      if (tax !== '0' && terms.length > 0) {
                        val = 'taxonomy: ' + tax + '/' + terms.join(',')
                      }
                    }
                    // Deselect
                    else if (source === '0') {
                      val = 'none'
                    }
                    // Other options
                    else {
                      val = source
                    }
                    if (ids !== '') {
                      val = source + ': ' + ids
                    }
                    $val.val(val).trigger('change')
                  }
                  // Switch source
                  $sources.on(
                    'change',
                    function (e) {
                      var source = $(this).val()
                      e.preventDefault()
                      $source.removeClass('su-generator-isp-source-open')
                      if (source.indexOf(':') === -1) {
                        $picker.find('.su-generator-isp-source-' + source).addClass('su-generator-isp-source-open')
                      }
                      update()
                    }
                  )
                  // Remove image
                  $images.on(
                    'click',
                    'span i',
                    function () {
                      $(this).parent('span').css('border-color', '#f03').fadeOut(
                        300,
                        function () {
                          $(this).remove()
                          update()
                        }
                      )
                    }
                  )
                  // Add image
                  $addMedia.click(
                    function (e) {
                      e.preventDefault()
                      if (typeof (frame) !== 'undefined') {
                        frame.close()
                      }
                      frame = wp.media.frames.su_media_frame_1 = wp.media(
                        {
                          title: SUGL10n.isp_media_title,
                          library: {
                            type: 'image'
                          },
                          button: {
                            text: SUGL10n.isp_media_insert
                          },
                          multiple: true
                        }
                      )
                      frame.on('open', function () {
                        $('.mfp-wrap').addClass('hidden')
                      })
                      frame.on('close', function () {
                        $('.mfp-wrap').removeClass('hidden')
                      })
                      frame.on(
                        'select',
                        function () {
                          var files = frame.state().get('selection').toJSON()
                          $images.find('em').remove()
                          $.each(
                            files,
                            function (i) {
                              $images.append('<span data-id="' + this.id + '"><img src="' + this.url + '" alt="" /><i class="sui sui-times"></i></span>')
                            }
                          )
                          update()
                        }
                      ).open()
                    }
                  )
                  // Sort images
                  $images.sortable(
                    {
                      revert: 200,
                      containment: $picker,
                      tolerance: 'pointer',
                      stop: function () {
                        update()
                      }
                    }
                  )
                  // Select categories and terms
                  $cats.on('change', update)
                  $terms.on('change', update)
                  // Select taxonomy
                  $taxes.on(
                    'change',
                    function () {
                      var $cont = $(this).parents('.su-generator-isp-source')
                      var tax = $(this).val()
                      // Remove terms
                      $terms.hide().find('option').remove()
                      update()
                      // Taxonomy is not selected
                      if (tax === '0') {

                      } else { // Taxonomy selected
                        var ajaxTermSelect = $.ajax(
                          {
                            url: ajaxurl,
                            type: 'post',
                            dataType: 'html',
                            data: {
                              action: 'su_generator_get_terms',
                              tax: tax,
                              class: 'su-generator-isp-terms',
                              multiple: true,
                              size: 10
                            },
                            beforeSend: function () {
                              if (typeof ajaxTermSelect === 'object') {
                                ajaxTermSelect.abort()
                              }
                              $terms.html('').attr('disabled', true).hide()
                              $cont.addClass('su-generator-loading')
                            },
                            success: function (data) {
                              $terms.html(data).attr('disabled', false).show()
                              $cont.removeClass('su-generator-loading')
                            }
                          }
                        )
                      }
                    }
                  )
                }
              )
              // Init media buttons
              $('.su-generator-upload-button').each(
                function () {
                  var $button = $(this)
                  var $val = $(this).parents('.su-generator-attr-container').find('input:text')
                  var file
                  $button.on(
                    'click',
                    function (e) {
                      e.preventDefault()
                      e.stopPropagation()
                      // If the frame already exists, reopen it
                      if (typeof (file) !== 'undefined') {
                        file.close()
                      }
                      // Create WP media frame.
                      file = wp.media.frames.su_media_frame_2 = wp.media(
                        {
                          // Title of media manager frame
                          title: SUGL10n.upload_title,
                          button: {
                            // Button text
                            text: SUGL10n.upload_insert
                          },
                          // Do not allow multiple files, if you want multiple, set true
                          multiple: false
                        }
                      )
                      // callback for selected image
                      file.on(
                        'select',
                        function () {
                          var attachment = file.state().get('selection').first().toJSON()
                          $val.val(attachment.url).trigger('change')
                        }
                      )
                      file.on('open', function () {
                        $('.mfp-wrap').addClass('hidden')
                      })
                      file.on('close', function () {
                        $('.mfp-wrap').removeClass('hidden')
                      })
                      // Open modal
                      file.open()
                    }
                  )
                }
              )
              // Init icon pickers
              $('.su-generator-icon-picker-button').each(
                function () {
                  var $button = $(this)
                  var $field = $(this).parents('.su-generator-attr-container')
                  var $val = $field.find('.su-generator-attr')
                  var $picker = $field.find('.su-generator-icon-picker')
                  var $filter = $picker.find('input:text')
                  $button.click(
                    function (e) {
                      $picker.toggleClass('su-generator-icon-picker-visible')
                      $filter.val('').trigger('keyup')
                      if ($picker.hasClass('su-generator-icon-picker-loaded')) {
                        return
                      }
                      // Load icons
                      $.ajax(
                        {
                          type: 'post',
                          url: ajaxurl,
                          data: {
                            action: 'su_generator_get_icons'
                          },
                          dataType: 'html',
                          beforeSend: function () {
                            // Show loading animation
                            $picker.addClass('su-generator-loading')
                            // Add loaded class
                            $picker.addClass('su-generator-icon-picker-loaded')
                          },
                          success: function (data) {
                            $picker.append(data)
                            var $icons = $picker.children('i')
                            $icons.click(
                              function (e) {
                                $val.val('icon: ' + $(this).attr('title'))
                                $picker.removeClass('su-generator-icon-picker-visible')
                                $val.trigger('change')
                                e.preventDefault()
                              }
                            )
                            $filter.on(
                              {
                                keyup: function () {
                                  var val = $(this).val()
                                  var regex = new RegExp(val, 'gi')
                                  // Hide all choices
                                  $icons.hide()
                                  // Find searched choices and show
                                  $icons.each(
                                    function () {
                                      // Get shortcode name
                                      var name = $(this).attr('title')
                                      // Show choice if matched
                                      if (name.match(regex) !== null) {
                                        $(this).show()
                                      }
                                    }
                                  )
                                },
                                focus: function () {
                                  $(this).val('')
                                  $icons.show()
                                }
                              }
                            )
                            $picker.removeClass('su-generator-loading')
                          }
                        }
                      )
                      e.preventDefault()
                    }
                  )
                }
              )
              // Init switches
              $('.su-generator-switch').click(
                function (e) {
                  // Prepare data
                  var $switch = $(this)
                  var $value = $switch.parent().children('input')
                  var isOn = $value.val() === 'yes'
                  // Disable
                  if (isOn) {
                    // Change value
                    $value.val('no').trigger('change')
                  } else { // Enable
                    // Change value
                    $value.val('yes').trigger('change')
                  }
                  e.preventDefault()
                }
              )
              $('.su-generator-switch-value').on(
                'change',
                function () {
                  // Prepare data
                  var $value = $(this)
                  var $switch = $value.parent().children('.su-generator-switch')
                  var value = $value.val()
                  // Disable
                  if (value === 'yes') {
                    $switch
                      .removeClass('su-generator-switch-no')
                      .addClass('su-generator-switch-yes')
                      .attr('aria-checked', 'true')
                  } else if (value === 'no') { // Enable
                    $switch
                      .removeClass('su-generator-switch-yes')
                      .addClass('su-generator-switch-no')
                      .attr('aria-checked', 'false')
                  }
                }
              )
              // Init searchable selects
              initSearchableSelects($settings)
              // Init sortable checkbox fields
              initSortableCheckboxes($settings)
              // Init image radio fields
              initImageRadios($settings)
              // Init radio fields
              initRadios($settings)
              // Init tax_term selects
              $('select#su-generator-attr-taxonomy').on(
                'change',
                function () {
                  var $taxonomy = $(this)
                  var tax = $taxonomy.val()
                  var $terms = $('select#su-generator-attr-tax_term')
                  // Load new options
                  window.su_generator_get_terms = $.ajax(
                    {
                      type: 'POST',
                      url: ajaxurl,
                      data: {
                        action: 'su_generator_get_terms',
                        tax: tax,
                        noselect: true
                      },
                      dataType: 'html',
                      beforeSend: function () {
                        // Check previous requests
                        if (typeof window.su_generator_get_terms === 'object') {
                          window.su_generator_get_terms.abort()
                        }
                        // Show loading animation
                        $terms.parent().addClass('su-generator-loading')
                      },
                      success: function (data) {
                        // Remove previous options
                        $terms.find('option').remove()
                        // Append new options
                        $terms.append(data)
                        // Hide loading animation
                        $terms.parent().removeClass('su-generator-loading')
                      }
                    }
                  )
                }
              )
              // Init shadow pickers
              $('.su-generator-shadow-picker').each(
                function (index) {
                  var $picker = $(this)
                  var $fields = $picker.find('.su-generator-shadow-picker-field input')
                  var $hoff = $picker.find('.su-generator-sp-hoff')
                  var $voff = $picker.find('.su-generator-sp-voff')
                  var $blur = $picker.find('.su-generator-sp-blur')
                  var $color = {
                    cnt: $picker.find('.su-generator-shadow-picker-color'),
                    value: $picker.find('.su-generator-shadow-picker-color-value'),
                    wheel: $picker.find('.su-generator-shadow-picker-color-wheel')
                  }
                  var $val = $picker.find('.su-generator-attr')
                  // Init color picker
                  $color.wheel.farbtastic($color.value)
                  $color.value.focus(
                    function () {
                      $color.wheel.show()
                    }
                  )
                  $color.value.blur(
                    function () {
                      $color.wheel.hide()
                    }
                  )
                  // Handle text fields
                  $fields.on(
                    'change blur keyup',
                    function () {
                      $val.val($hoff.val() + 'px ' + $voff.val() + 'px ' + $blur.val() + 'px ' + $color.value.val()).trigger('change')
                    }
                  )
                  $val.on(
                    'keyup',
                    function () {
                      var value = $(this).val().split(' ')
                      // Value is correct
                      if (value.length === 4) {
                        $hoff.val(value[0].replace('px', ''))
                        $voff.val(value[1].replace('px', ''))
                        $blur.val(value[2].replace('px', ''))
                        $color.value.val(value[3])
                        $fields.trigger('keyup')
                      }
                    }
                  )
                }
              )
              // Init border pickers
              $('.su-generator-border-picker').each(
                function (index) {
                  var $picker = $(this)
                  var $fields = $picker.find('.su-generator-border-picker-field input, .su-generator-border-picker-field select')
                  var $width = $picker.find('.su-generator-bp-width')
                  var $style = $picker.find('.su-generator-bp-style')
                  var $color = {
                    cnt: $picker.find('.su-generator-border-picker-color'),
                    value: $picker.find('.su-generator-border-picker-color-value'),
                    wheel: $picker.find('.su-generator-border-picker-color-wheel')
                  }
                  var $val = $picker.find('.su-generator-attr')
                  // Init color picker
                  $color.wheel.farbtastic($color.value)
                  $color.value.focus(
                    function () {
                      $color.wheel.show()
                    }
                  )
                  $color.value.blur(
                    function () {
                      $color.wheel.hide()
                    }
                  )
                  // Handle text fields
                  $fields.on(
                    'change blur keyup',
                    function () {
                      $val.val($width.val() + 'px ' + $style.val() + ' ' + $color.value.val()).trigger('change')
                    }
                  )
                  $val.on(
                    'keyup',
                    function () {
                      var value = $(this).val().split(' ')
                      // Value is correct
                      if (value.length === 3) {
                        $width.val(value[0].replace('px', ''))
                        $style.val(value[1])
                        $color.value.val(value[2])
                        $fields.trigger('keyup')
                      }
                    }
                  )
                }
              )
              // Remove skip class when setting is changed
              $settings.find('.su-generator-attr').on(
                'change keyup blur',
                function () {
                  var $cnt = $(this).parents('.su-generator-attr-container')
                  var _default = $cnt.data('default')
                  var val = $(this).val()
                  // Value is changed
                  if (val != _default) {
                    $cnt.removeClass('su-generator-skip')
                  } else {
                    $cnt.addClass('su-generator-skip')
                  }
                }
              )
              // Bind updating shortcode preview on settings changes
              $settings.find('input, textarea, select').on(
                'change keyup blur',
                function () {
                  self.updateShortcodePreview()
                  self.updatePreview()
                }
              )
              // Init value setters
              $('.su-generator-set-value').click(
                function (e) {
                  $(this).parents('.su-generator-attr-container').find('input').val($(this).text()).trigger('change')
                }
              )
              // Init settings tabs after controls are ready.
              initGeneratorTabs($settings)
              // Init fields shown only for specific setting values.
              initDependentFields($settings)
              // Save selected value
              $selected.val(shortcode)
              self.updateShortcodePreview()
              self.updatePreview(true)
              // Load last used preset
              abortLastUsedRequest()
              var lastUsedRequest = $.ajax(
                {
                  type: 'GET',
                  url: ajaxurl,
                  data: {
                    action: 'su_generator_get_preset',
                    id: 'last_used',
                    shortcode: shortcode,
                    nonce: $('#su_generator_presets_nonce').val()
                  },
                  beforeSend: function () {
                    // Show loading animation
                    // $settings.addClass('su-generator-loading');
                  },
                  success: function (data) {
                    // Remove loading animation
                    // $settings.removeClass('su-generator-loading');
                    // Set new settings
                    self.setSettings(data)
                    // Apply selected text to the content field
                    var $content = $('#su-generator-content')
                    if (typeof self.state.mceSelection !== 'undefined' && self.state.mceSelection !== '' && $content.attr('type') !== 'hidden') {
                      $content.val(self.state.mceSelection)
                      self.updateShortcodePreview()
                      self.updatePreview(true)
                    }
                  },
                  complete: function () {
                    if (self.state.lastUsedRequest === lastUsedRequest) {
                      self.state.lastUsedRequest = null
                    }
                  },
                  dataType: 'json'
                }
              )
              self.state.lastUsedRequest = lastUsedRequest
            },
            dataType: 'html'
          }
        )
      }
    )
    // Insert shortcode
    $('#su-generator').on('click', '.su-generator-insert', self.insertShortcode)
    // Copy shortcode
    $('#su-generator').on('click', '.su-generator-copy', self.copyShortcode)
    // Reset shortcode settings
    $('#su-generator').on('click', '.su-generator-reset', self.resetSettings)
    var gp_hover_timer
    // Presets manager - mouseenter
    $('#su-generator').on(
      'mouseenter click',
      '.su-generator-presets',
      function () {
        clearTimeout(gp_hover_timer)
        $('.su-gp-popup').show()
      }
    )
    // Presets manager - mouseleave
    $('#su-generator').on(
      'mouseleave',
      '.su-generator-presets',
      function () {
        gp_hover_timer = window.setTimeout(
          function () {
            $('.su-gp-popup').fadeOut(200)
          },
          600
        )
      }
    )
    // Presets manager - add new preset
    $('#su-generator').on(
      'click',
      '.su-gp-new',
      function (e) {
        // Prepare data
        var $container = $(this).parents('.su-generator-presets')
        var $list = $('.su-gp-list')
        var id = new Date().getTime()
        // Ask for preset name
        var name = prompt(SUGL10n.presets_prompt_msg, SUGL10n.presets_prompt_value)
        // Name is entered
        if (name !== '' && name !== null) {
          // Hide default text
          $list.find('b').hide()
          // Add new option
          $list.append('<span data-id="' + id + '"><em>' + name + '</em><i class="sui sui-times"></i></span>')
          // Perform AJAX request
          self.addPreset(id, name)
        }
      }
    )
    // Presets manager - load preset
    $('#su-generator').on(
      'click',
      '.su-gp-list span',
      function (e) {
        // Prepare data
        var shortcode = $('.su-generator-presets').data('shortcode')
        var id = $(this).data('id')
        var $insert = $('.su-generator-insert')
        // Hide popup
        $('.su-gp-popup').hide()
        // Disable hover timer
        clearTimeout(gp_hover_timer)
        // Get the preset
        $.ajax(
          {
            type: 'GET',
            url: ajaxurl,
            data: {
              action: 'su_generator_get_preset',
              id: id,
              shortcode: shortcode,
              nonce: $('#su_generator_presets_nonce').val()
            },
            beforeSend: function () {
              // Disable insert button
              $insert.addClass('button-primary-disabled').attr('disabled', true)
            },
            success: function (data) {
              // Enable insert button
              $insert.removeClass('button-primary-disabled').attr('disabled', false)
              // Set new settings
              self.setSettings(data)
            },
            dataType: 'json'
          }
        )
        // Prevent default action
        e.preventDefault()
        e.stopPropagation()
      }
    )
    // Presets manager - remove preset
    $('#su-generator').on(
      'click',
      '.su-gp-list i',
      function (e) {
        // Prepare data
        var $preset = $(this).parent('span')
        var id = $preset.data('id')
        // Remove DOM element
        removePresetElement($preset)
        // Perform ajax request
        self.removePreset(id)
        // Prevent <span> action
        e.stopPropagation()
        // Prevent default action
        e.preventDefault()
      }
    )
  }

  self.addPreset = function (id, name) {
    // Prepare shortcode name and current settings
    var shortcode = $('.su-generator-presets').data('shortcode')
    var settings = self.getSettings()
    // Perform AJAX request
    $.ajax(
      {
        type: 'POST',
        url: ajaxurl,
        data: {
          action: 'su_generator_add_preset',
          id: id,
          name: name,
          shortcode: shortcode,
          settings: settings,
          nonce: $('#su_generator_presets_nonce').val()
        }
      }
    )
  }

  self.removePreset = function (id) {
    // Get current shortcode name
    var shortcode = $('.su-generator-presets').data('shortcode')
    // Perform AJAX request
    $.ajax(
      {
        type: 'POST',
        url: ajaxurl,
        data: {
          action: 'su_generator_remove_preset',
          id: id,
          shortcode: shortcode,
          nonce: $('#su_generator_presets_nonce').val()
        }
      }
    )
  }

  self.parseSettings = function () {
    var settingsSelector = $('#su-generator-option-skip').val() === 'on'
      ? '#su-generator-settings .su-generator-attr-container:not(.su-generator-skip) .su-generator-attr'
      : '#su-generator-settings .su-generator-attr-container .su-generator-attr'
    // Prepare data
    var query = $selected.val()
    var prefix = $prefix.val()
    var $settings = $(settingsSelector)
    var $content = $('textarea#su-generator-content')
    var content = $content.length ? $content.val() : 'false'
    var result = new String('')
    // Open shortcode
    result += '[' + prefix + query
    // Add shortcode attributes
    $settings.each(
      function () {
        // Prepare field and value
        var $this = $(this)
        var value = ''
        // Selects
        if ($this.is('select')) {
          value = $this.find('option:selected').val()
        }
        // Other fields
        else {
          value = $this.val()
        }
        // Check that value is not empty
        if (value == null) {
          value = ''
        } else if (typeof value === 'array') {
          value = value.join(',')
        }
        // Add attribute
        if (value !== '') {
          result += ' ' + $(this).attr('name') + '="' + $(this).val().toString().replace(/"/gi, "'") + '"'
        }
      }
    )
    // End of opening tag
    result += ']'
    // Wrap shortcode if content presented
    if (content != 'false') {
      result += content + '[/' + prefix + query + ']'
    }
    // Return result
    return result
  }

  self.getSettings = function () {
    // Prepare data
    var query = $selected.val()
    var $settings = $('#su-generator-settings .su-generator-attr')
    var $content = $('textarea#su-generator-content')
    var content = $content.length ? $content.val() : 'false'
    var data = {}
    // Add shortcode attributes
    $settings.each(
      function (i) {
        // Prepare field and value
        var $this = $(this)
        var value = ''
        var name = $this.attr('name')
        // Selects
        if ($this.is('select')) {
          value = $this.find('option:selected').val()
        }
        // Other fields
        else {
          value = $this.val()
        }
        // Check that value is not empty
        if (value == null) {
          value = ''
        }
        // Save value
        data[name] = value
      }
    )
    // Add content
    data.content = content.toString()
    // Return data
    return data
  }

  self.setSettings = function (data) {
    // Prepare data
    var $settings = $('#su-generator-settings .su-generator-attr')
    var $content = $('#su-generator-content')
    // Loop through settings
    $settings.each(
      function () {
        var $this = $(this)
        var name = $this.attr('name')
        // Data contains value for this field
        if (data.hasOwnProperty(name)) {
          // Set new value
          $this.val(data[name])
          $this.trigger('keyup').trigger('change').trigger('blur')
        }
      }
    )
    // Set content
    if (data.hasOwnProperty('content')) {
      $content.val(data.content).trigger('keyup').trigger('change').trigger('blur')
    }
    // Update preview
    self.updateShortcodePreview()
    self.updatePreview(true)
  }

  self.setShortcodePreview = function (shortcode) {
    var $shortcodePreview = $('#su-generator-shortcode-preview')
    var $code = $shortcodePreview.find('code')

    if ($code.length) {
      $code.text(shortcode)
    } else {
      $shortcodePreview.text(shortcode)
    }
  }

  self.updateShortcodePreview = function () {
    self.setShortcodePreview(self.parseSettings())
  }

  self.resetSettings = function (e) {
    if (!self.state.defaultSettings) {
      return
    }

    abortLastUsedRequest()
    self.setSettings($.extend({}, self.state.defaultSettings))
    removePresetElement($('.su-gp-list span').filter(function () {
      return String($(this).data('id')) === 'last_used'
    }))
    self.removePreset('last_used')

    if (e) {
      e.preventDefault()
    }
  }

  self.copyShortcode = function (e) {
    var $button = $(this)
    var shortcode = self.parseSettings()
    var showCopied = function () {
      setCopyButtonState($button, true)

      window.setTimeout(
        function () {
          setCopyButtonState($button, false)
        },
        1600
      )
    }

    self.setShortcodePreview(shortcode)
    self.addPreset('last_used', SUGL10n.last_used)

    if (navigator.clipboard && navigator.clipboard.writeText) {
      $.when(navigator.clipboard.writeText(shortcode))
        .done(showCopied)
        .fail(
          function () {
            if (fallbackCopyText(shortcode)) {
              showCopied()
            }
          }
        )

      e.preventDefault()
      return
    }

    if (fallbackCopyText(shortcode)) {
      showCopied()
    }

    e.preventDefault()
  }

  self.updatePreview = function (forced) {
    // Prepare data
    var $preview = $('#su-generator-preview')
    var shortcode = self.parseSettings()
    var previous = $result.text()
    // Check forced mode
    forced = forced || false
    // Break if preview box is hidden (preview isn't enabled)
    if (!$preview.is(':visible')) {
      return
    }
    // Check shortcode is changed is this is not a forced mode
    if (shortcode === previous && !forced) {
      return
    }
    // Run timer to filter often calls
    window.clearTimeout(self.state.preview.timer)
    self.state.preview.timer = window.setTimeout(
      function () {
        self.state.preview.request = $.ajax(
          {
            type: 'POST',
            url: ajaxurl,
            cache: false,
            data: {
              action: 'su_generator_preview',
              shortcode: shortcode,
              nonce: $('#su_generator_preview_nonce').val()
            },
            beforeSend: function () {
              // Abort previous requests
              if (self.state.preview.request) {
                self.state.preview.request.abort()
              }
              // Show loading animation
              $preview.addClass('su-generator-loading').html('')
            },
            success: function (data) {
              // Hide loading animation and set new HTML
              $preview.html(data).removeClass('su-generator-loading')
            },
            dataType: 'html'
          }
        )
      },
      300
    )
    // Save shortcode to div
    $result.text(shortcode)
  }

  self.insert = function (context, args) {
    if (typeof context !== 'string' || typeof args !== 'object') {
      return
    }

    self.state.context = context
    self.state.insertArgs = args

    var preSelectedShortcode = args.shortcode || ''

    var mfpOptions = {
      type: 'inline',
      alignTop: true,
      closeOnBgClick: false,
      mainClass: 'su-generator-mfp',
      items: {
        src: '#su-generator'
      },
      callbacks: {}
    }

    mfpOptions.callbacks.open = () => {
      if (preSelectedShortcode) {
        $choice.filter(`[data-shortcode="${preSelectedShortcode}"]`).trigger('click')
      } else {
        window.setTimeout(() => $search.focus(), 200)
      }

      if (
        typeof tinyMCE !== 'undefined' &&
				tinyMCE.activeEditor != null &&
				tinyMCE.activeEditor.hasOwnProperty('selection')
      ) {
        self.state.mceSelection = tinyMCE.activeEditor.selection.getContent({ format: 'text' })
      }
    }

    mfpOptions.callbacks.close = () => {
      clearSearch()
      showChoicesMode()

      self.state.mceSelection = ''
    }

    $.magnificPopup.open(mfpOptions)
  }

  self.insertShortcode = function () {
    var shortcode = self.parseSettings()

    self.addPreset('last_used', SUGL10n.last_used)

    $.magnificPopup.close()

    $result.text(shortcode)

    if (self.state.context === 'html') {
      var HTMLEditor = document.getElementById(self.state.insertArgs.editorID)
      self.insertAtCaret(HTMLEditor, shortcode)
    }

    if (self.state.context === 'classic') {
      window.wp.media.editor.insert(shortcode)
    }

    if (self.state.context === 'block') {
      var props = self.state.insertArgs.props

      if (props.attributes.hasOwnProperty('content')) {
        props.setAttributes({ content: props.attributes.content + shortcode })
      } else if (props.name === 'core/shortcode') {
        var originalText = props.attributes.hasOwnProperty('text')
          ? props.attributes.text
          : ''

        props.setAttributes({ text: originalText + shortcode })
      }
    }

    if (self.state.context === 'callback') {
      if (typeof self.state.insertArgs.callback === 'function') {
        self.state.insertArgs.callback(shortcode)
      }
    }
  }

  self.insertAtCaret = (field, text) => {
    var start = field.selectionStart
    field.value = field.value.substring(0, start) + text + field.value.substring(start)
    field.focus()
    field.selectionStart = start + text.length
  }

  return {
    init: self.init,
    insert: self.insert
  }
})(jQuery)

jQuery(document).ready(window.SUG.App.init)
